export const tr = {
    'request-error': 'Hata oluştu. Lütfen, tekrar deneyin.'
};
